import { Reducer } from 'redux';
import { AuthAction } from '../types/auth-types'
import UserModel from '../../models/user-model';
import FLUX_AUTH_CONSTANTS from '../constants/auth-constants';

export interface AuthReducerState {
    backTo?: string
    loading: boolean
    errorMessage?: string
    errorStatus?: number
    loginError: boolean
    user: UserModel
    loadingUserData: boolean
}

const initialState: AuthReducerState = {
    backTo: undefined,
    loading: false,
    errorMessage: "",
    errorStatus: 0,
    loginError: false,
    user: {} as UserModel,
    loadingUserData: false,
};


export const authReducer: Reducer<AuthReducerState, AuthAction> = (state = initialState, action: AuthAction) => {
    let errorMessage = "ERROR"
    switch (action.type) {
        case FLUX_AUTH_CONSTANTS.BACK_WHEN_LOGIN:
            return {
                ...state,
                backTo: action.page
            }
        //------------------ LOGIN -----------------------------
        case FLUX_AUTH_CONSTANTS.LOGIN_BEGIN:
            return {
                ...state,
                errorMessage: "",
                loading: true,
                loginError: false,
                errorStatus: 0
            }

        case FLUX_AUTH_CONSTANTS.LOGIN_ERROR:
            errorMessage = "ERROR"
            if (action.error && action.error.data) {
                errorMessage = action.error.data.errors ? action.error.data.errors.emailOrPassword : action.error.data.error
            }
            return {
                ...state,
                errorMessage: errorMessage,
                errorStatus: action.error ? action.error.status : 0,
                loginError: true,
                loading: false
            }

        case FLUX_AUTH_CONSTANTS.LOGIN_SUCCESS:
            return {
                ...state,
                errorMessage: "",
                loginError: false,
                loading: false,
                user: action.data,
                errorStatus: 0
            }
        //------------------ SIGNUP -----------------------------
        case FLUX_AUTH_CONSTANTS.SIGNUP_BEGIN:
            return {
                ...state,
                errorMessage: "",
                loading: true,
                loginError: false,
                errorStatus: 0
            }

        case FLUX_AUTH_CONSTANTS.SIGNUP_ERROR:
            errorMessage = "ERROR"
            if (action.error ||  action.error.data) {
                errorMessage = action.error.data.errors ? action.error.data.errors.email : action.error.data.error
            }
            return {
                ...state,
                errorMessage: errorMessage,
                errorStatus: action.error ? action.error.status : 0,
                loginError: true,
                loading: false
            }

        case FLUX_AUTH_CONSTANTS.SIGNUP_SUCCESS:
            return {
                ...state,
                errorMessage: "",
                loginError: false,
                loading: false,
                user: action.data,
                errorStatus: 0
            }

        //------------------ LOGOUT -----------------------------
        case FLUX_AUTH_CONSTANTS.LOGOUT_BEGIN:
            return {
                ...state,
                errorMessage: "",
                loading: true,
                loginError: false,
            }

        case FLUX_AUTH_CONSTANTS.LOGOUT_ERROR:
            return {
                ...state,
                errorMessage: action.error && action.error.data.error,
                errorStatus: action.error && action.error.status,
                loading: false,
                loginError: false,
            }

        case FLUX_AUTH_CONSTANTS.LOGOUT_SUCCESS:
            return {
                ...initialState
            }
            
        case FLUX_AUTH_CONSTANTS.CLEAR_AUTH_LOADING:
            return {
                ...state,
                loading: false,
                loadingUserData: false,
                errorMessage: '',
                errorStatus: 0
            }

        case FLUX_AUTH_CONSTANTS.EDIT_INFO:
            return {
                ...state,
                user: action.data,
                loading:false
            }

        case FLUX_AUTH_CONSTANTS.EDIT_INFO_ERROR:

            if(action.error === undefined)  errorMessage = "ERROR"

            if (action.error ||  action.error?.data) {
                errorMessage = action.error.data.errors ? action.error.data.errors.email : action.error.data.error
            }

            return {
                ...state,
                errorMessage: errorMessage,
                errorStatus: action.error ? action.error.status : 0,
                loginError: true,
                loading: false
            }

        case FLUX_AUTH_CONSTANTS.EDIT_INFO_BEGIN:
            return{
                ...state,
                errorMessage: "",
                loading: true,
                loginError: false,
                errorStatus: 0
            }
            
            
        default:
            return state
    }
}
